import gql from 'graphql-tag'

export const getWeixinRefund = gql`
    query($order: [RefundsFindOrder!], $paging: PagingQuery, $where: RefundsFindFilter) {
        findWeixinRefunds(
            order: $order,
            paging: $paging,
            where: $where
        ) {
            refunds {
                id
                refundNumber
                orderId
                totalPrice
                order {
                    orderNumber
                    timeEnd
                    dealer {
                        realname
                        storePhone
                    }
                    address {
                        realname
                        phone
                    }
                phone
                realname
                }
                auditStatus
                createdAt
            }
            paging {
                currentOffset
                take
                totalCount
            }
        }
    }
`

export const handleRefundAudit = gql`
    mutation($approve: Boolean!, $orderIds: [Int!]!) {
        auditRefund(approve: $approve, orderIds: $orderIds)
    }
`

export const exportWeixinRefundsList = gql`
  query($order: [RefundsFindOrder!],$where: RefundsFindFilter) {
    exportRefundsList(
      order: $order,
      where: $where
    ) {
      fileName
      contentB64
    }
  }
`
